import React, { useState } from "react";
import axios from "axios";
import Spinner from "../../common/Spinner/Spinner.jsx";
import { ReactComponent as Error } from "../../common/icons/red-x.svg";
import { ReactComponent as CheckMark } from "../../common/icons/checkmark.svg";

const EmailTimesheet = ({ companyRef, weekEnd, setIsEmailPopUpOpen }) => {
  const [emailsList, setEmailsList] = useState([""]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const addMore = () => {
    setEmailsList([...emailsList, ""]);
  };

  const removeEmail = index => {
    const newList = emailsList.filter((el, i) => i !== index);
    return setEmailsList(newList);
  };

  const onChangeEmail = (event, index) => {
    const text = event.target.value;
    const changedEmail = emailsList.map((el, i) => {
      if (index === i) {
        return text;
      }
      return el;
    });
    return setEmailsList(changedEmail);
  };

  const handleSubmit = async () => {
    setLoading(true);
    await Promise.all(
      emailsList.map(async email => {
        await axios
          .post(
            `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/email`,
            {
              timesheet: {
                emailAddress: email,
                endDate: weekEnd,
                ref: companyRef
              }
            },
            {
              headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
            }
          )
          .then(() => setLoading(false))
          .catch(e => {
            setLoading(false);
            console.log(e);
            setStatus("error");
          });
      })
    );
    setLoading(false);
    setStatus("success");
  };

  const determineIfValid = () => {
    let disable = false;

    // eslint-disable-next-line
    emailsList.find(el => {
      if (
        el === "" ||
        !el.match(
          // eslint-disable-next-line
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      )
        disable = true;
    });
    return disable;
  };

  return (
    <div className="timesheets__summary-tableWrapper">
      <div className="timesheets__summary">
        <div className="timesheets__summary-title tw-text-2xl tw-font-bold ">
          Email Timesheet Summary
        </div>
        <div className="tw-px-2">
          Please enter at least one email address you wish to send the timesheet
          summary onto.
        </div>
        {status === "error" && (
          <div className="tw-w-full tw-py-8 tw-flex tw-justify-center tw-flex-col tw-items-center">
            <Error />
            <p className="tw-my-4">
              Sorry! Something went wrong. Try again later.
            </p>
          </div>
        )}
        {status === "success" && (
          <div className="tw-w-full tw-py-8 tw-flex tw-justify-center tw-flex-col tw-items-center">
            <CheckMark />
            <p className="tw-my-4">Success! Email has been sent.</p>
          </div>
        )}
        {!status && (
          <div className="timesheets__table">
            {emailsList.map((el, i) => (
              <div className="tw-flex">
                <input
                  onChange={event => onChangeEmail(event, i)}
                  type="email"
                  placeholder="Email Address"
                  className="tw-border-2 tw-border-gray-600 tw-w-full tw-p-2 tw-my-1"
                  value={emailsList[i]}
                />
                {i !== 0 ? (
                  <button className="btn" onClick={() => removeEmail(i)}>
                    Delete
                  </button>
                ) : (
                  <div className="" />
                )}
              </div>
            ))}

            <button
              className="btn tw-w-full tw-justify-center btn-secondary tw-text-white tw-flex"
              onClick={addMore}
            >
              Add more
            </button>
          </div>
        )}
      </div>
      <div
        className={`${
          !status ? "timesheets__summary-buttons" : "timesheets__status-success"
        } `}
      >
        <button
          className="btn btn-primary timesheets__summary-button"
          onClick={() => setIsEmailPopUpOpen(false)}
        >
          Close
        </button>
        {!status && (
          <button
            disabled={loading || determineIfValid()}
            type="submit"
            className={`btn btn-primary timesheets__summary-button tw-flex tw-justify-${
              loading ? "between" : "center"
            }`}
            onClick={handleSubmit}
          >
            Send Email/s
            {loading && <Spinner />}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmailTimesheet;
